<template>
  <scout-form
    :is-modified="isModifiedExcludeEntryOtherCompany"
    label="他社求人への応募"
  >
    <div
      v-for="(label,i) in labels"
      :key="i"
    >
      <label class="boss-checkbox">
        <input
          :checked="label.value"
          class="boss-input-checkbox"
          type="checkbox"
          :data-test="`input-applies-other-${i}`"
          @change="$emit(`update:${label.target}`, $event.target.checked)"
        >{{ label.name }}
      </label>
    </div>
  </scout-form>
</template>

<script>
import ScoutForm from '@/components/atoms/ScoutForm'
import _ from 'lodash'
import * as definition from '@/lib/labelValueMappings'

export default {
  components: {
    ScoutForm
  },
  props: {
    appliesOtherCompany: {
      default: false,
      type: Boolean
    },
    appliesCasualInterviewEntryOtherCompany: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    labels () {
      return [
        {
          value: this.appliesOtherCompany,
          target: 'appliesOtherCompany',
          name: _.find(definition.excludeEntryOtherCompanyJob, { key: 'excludeEntryOtherCompanyJob' }).label
        },
        {
          value: this.appliesCasualInterviewEntryOtherCompany,
          target: 'appliesCasualInterviewEntryOtherCompany',
          name: _.find(definition.excludeEntryOtherCompanyJob, { key: 'excludeCasualInterviewEntryOtherCompanyJob' }).label
        }
      ]
    },
    isModifiedExcludeEntryOtherCompany () {
      return this.appliesOtherCompany || this.appliesCasualInterviewEntryOtherCompany
    }
  }
}
</script>
